// source: legebill/type/tag.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.legebill.type.Tag', null, global);
goog.exportSymbol('proto.legebill.type.Tag.Source', null, global);
goog.exportSymbol('proto.legebill.type.Tag.Status', null, global);
goog.exportSymbol('proto.legebill.type.Tag.SuggestionConfig', null, global);
goog.exportSymbol('proto.legebill.type.TagKeyword', null, global);
goog.exportSymbol('proto.legebill.type.TagShallow', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.type.Tag = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.legebill.type.Tag.repeatedFields_, null);
};
goog.inherits(proto.legebill.type.Tag, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.type.Tag.displayName = 'proto.legebill.type.Tag';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.type.TagShallow = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.type.TagShallow, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.type.TagShallow.displayName = 'proto.legebill.type.TagShallow';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.type.TagKeyword = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.type.TagKeyword, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.type.TagKeyword.displayName = 'proto.legebill.type.TagKeyword';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.legebill.type.Tag.repeatedFields_ = [6,14];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.type.Tag.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.type.Tag.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.type.Tag} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.type.Tag.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    siteId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    tagCategoryId: jspb.Message.getFieldWithDefault(msg, 12, ""),
    name: jspb.Message.getFieldWithDefault(msg, 4, ""),
    description: jspb.Message.getFieldWithDefault(msg, 5, ""),
    keywordsList: jspb.Message.toObjectList(msg.getKeywordsList(),
    proto.legebill.type.TagKeyword.toObject, includeInstance),
    externalId: jspb.Message.getFieldWithDefault(msg, 7, ""),
    externalUrl: jspb.Message.getFieldWithDefault(msg, 8, ""),
    source: jspb.Message.getFieldWithDefault(msg, 9, 0),
    status: jspb.Message.getFieldWithDefault(msg, 10, 0),
    suggestionConfig: jspb.Message.getFieldWithDefault(msg, 11, 0),
    defaultActivityTypeId: jspb.Message.getFieldWithDefault(msg, 13, ""),
    assigneeExternalIdsList: (f = jspb.Message.getRepeatedField(msg, 14)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.type.Tag}
 */
proto.legebill.type.Tag.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.type.Tag;
  return proto.legebill.type.Tag.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.type.Tag} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.type.Tag}
 */
proto.legebill.type.Tag.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setTagCategoryId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 6:
      var value = new proto.legebill.type.TagKeyword;
      reader.readMessage(value,proto.legebill.type.TagKeyword.deserializeBinaryFromReader);
      msg.addKeywords(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setExternalId(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setExternalUrl(value);
      break;
    case 9:
      var value = /** @type {!proto.legebill.type.Tag.Source} */ (reader.readEnum());
      msg.setSource(value);
      break;
    case 10:
      var value = /** @type {!proto.legebill.type.Tag.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 11:
      var value = /** @type {!proto.legebill.type.Tag.SuggestionConfig} */ (reader.readEnum());
      msg.setSuggestionConfig(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setDefaultActivityTypeId(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.addAssigneeExternalIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.type.Tag.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.type.Tag.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.type.Tag} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.type.Tag.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTagCategoryId();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getKeywordsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.legebill.type.TagKeyword.serializeBinaryToWriter
    );
  }
  f = message.getExternalId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getExternalUrl();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getSource();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getSuggestionConfig();
  if (f !== 0.0) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = message.getDefaultActivityTypeId();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getAssigneeExternalIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      14,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.legebill.type.Tag.Source = {
  SOURCE_UNSPECIFIED: 0,
  USER: 1,
  CONNECTOR: 2
};

/**
 * @enum {number}
 */
proto.legebill.type.Tag.SuggestionConfig = {
  SUGGESTION_CONFIG_UNSPECIFIED: 0,
  ELIGIBLE: 1,
  DISALLOWED: 2
};

/**
 * @enum {number}
 */
proto.legebill.type.Tag.Status = {
  STATUS_UNSPECIFIED: 0,
  ENABLED: 1,
  ARCHIVED: 2
};

/**
 * optional string id = 1;
 * @return {string}
 */
proto.legebill.type.Tag.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.type.Tag} returns this
 */
proto.legebill.type.Tag.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string site_id = 2;
 * @return {string}
 */
proto.legebill.type.Tag.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.type.Tag} returns this
 */
proto.legebill.type.Tag.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string tag_category_id = 12;
 * @return {string}
 */
proto.legebill.type.Tag.prototype.getTagCategoryId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.type.Tag} returns this
 */
proto.legebill.type.Tag.prototype.setTagCategoryId = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string name = 4;
 * @return {string}
 */
proto.legebill.type.Tag.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.type.Tag} returns this
 */
proto.legebill.type.Tag.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string description = 5;
 * @return {string}
 */
proto.legebill.type.Tag.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.type.Tag} returns this
 */
proto.legebill.type.Tag.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * repeated TagKeyword keywords = 6;
 * @return {!Array<!proto.legebill.type.TagKeyword>}
 */
proto.legebill.type.Tag.prototype.getKeywordsList = function() {
  return /** @type{!Array<!proto.legebill.type.TagKeyword>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.legebill.type.TagKeyword, 6));
};


/**
 * @param {!Array<!proto.legebill.type.TagKeyword>} value
 * @return {!proto.legebill.type.Tag} returns this
*/
proto.legebill.type.Tag.prototype.setKeywordsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.legebill.type.TagKeyword=} opt_value
 * @param {number=} opt_index
 * @return {!proto.legebill.type.TagKeyword}
 */
proto.legebill.type.Tag.prototype.addKeywords = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.legebill.type.TagKeyword, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.legebill.type.Tag} returns this
 */
proto.legebill.type.Tag.prototype.clearKeywordsList = function() {
  return this.setKeywordsList([]);
};


/**
 * optional string external_id = 7;
 * @return {string}
 */
proto.legebill.type.Tag.prototype.getExternalId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.type.Tag} returns this
 */
proto.legebill.type.Tag.prototype.setExternalId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string external_url = 8;
 * @return {string}
 */
proto.legebill.type.Tag.prototype.getExternalUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.type.Tag} returns this
 */
proto.legebill.type.Tag.prototype.setExternalUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional Source source = 9;
 * @return {!proto.legebill.type.Tag.Source}
 */
proto.legebill.type.Tag.prototype.getSource = function() {
  return /** @type {!proto.legebill.type.Tag.Source} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.legebill.type.Tag.Source} value
 * @return {!proto.legebill.type.Tag} returns this
 */
proto.legebill.type.Tag.prototype.setSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional Status status = 10;
 * @return {!proto.legebill.type.Tag.Status}
 */
proto.legebill.type.Tag.prototype.getStatus = function() {
  return /** @type {!proto.legebill.type.Tag.Status} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.legebill.type.Tag.Status} value
 * @return {!proto.legebill.type.Tag} returns this
 */
proto.legebill.type.Tag.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional SuggestionConfig suggestion_config = 11;
 * @return {!proto.legebill.type.Tag.SuggestionConfig}
 */
proto.legebill.type.Tag.prototype.getSuggestionConfig = function() {
  return /** @type {!proto.legebill.type.Tag.SuggestionConfig} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {!proto.legebill.type.Tag.SuggestionConfig} value
 * @return {!proto.legebill.type.Tag} returns this
 */
proto.legebill.type.Tag.prototype.setSuggestionConfig = function(value) {
  return jspb.Message.setProto3EnumField(this, 11, value);
};


/**
 * optional string default_activity_type_id = 13;
 * @return {string}
 */
proto.legebill.type.Tag.prototype.getDefaultActivityTypeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.type.Tag} returns this
 */
proto.legebill.type.Tag.prototype.setDefaultActivityTypeId = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * repeated string assignee_external_ids = 14;
 * @return {!Array<string>}
 */
proto.legebill.type.Tag.prototype.getAssigneeExternalIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 14));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.legebill.type.Tag} returns this
 */
proto.legebill.type.Tag.prototype.setAssigneeExternalIdsList = function(value) {
  return jspb.Message.setField(this, 14, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.legebill.type.Tag} returns this
 */
proto.legebill.type.Tag.prototype.addAssigneeExternalIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 14, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.legebill.type.Tag} returns this
 */
proto.legebill.type.Tag.prototype.clearAssigneeExternalIdsList = function() {
  return this.setAssigneeExternalIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.type.TagShallow.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.type.TagShallow.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.type.TagShallow} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.type.TagShallow.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    siteId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    description: jspb.Message.getFieldWithDefault(msg, 4, ""),
    externalUrl: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.type.TagShallow}
 */
proto.legebill.type.TagShallow.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.type.TagShallow;
  return proto.legebill.type.TagShallow.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.type.TagShallow} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.type.TagShallow}
 */
proto.legebill.type.TagShallow.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setExternalUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.type.TagShallow.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.type.TagShallow.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.type.TagShallow} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.type.TagShallow.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getExternalUrl();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.legebill.type.TagShallow.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.type.TagShallow} returns this
 */
proto.legebill.type.TagShallow.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string site_id = 2;
 * @return {string}
 */
proto.legebill.type.TagShallow.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.type.TagShallow} returns this
 */
proto.legebill.type.TagShallow.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.legebill.type.TagShallow.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.type.TagShallow} returns this
 */
proto.legebill.type.TagShallow.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string description = 4;
 * @return {string}
 */
proto.legebill.type.TagShallow.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.type.TagShallow} returns this
 */
proto.legebill.type.TagShallow.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string external_url = 5;
 * @return {string}
 */
proto.legebill.type.TagShallow.prototype.getExternalUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.type.TagShallow} returns this
 */
proto.legebill.type.TagShallow.prototype.setExternalUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.type.TagKeyword.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.type.TagKeyword.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.type.TagKeyword} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.type.TagKeyword.toObject = function(includeInstance, msg) {
  var f, obj = {
    tagId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    text: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.type.TagKeyword}
 */
proto.legebill.type.TagKeyword.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.type.TagKeyword;
  return proto.legebill.type.TagKeyword.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.type.TagKeyword} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.type.TagKeyword}
 */
proto.legebill.type.TagKeyword.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTagId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.type.TagKeyword.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.type.TagKeyword.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.type.TagKeyword} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.type.TagKeyword.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTagId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string tag_id = 1;
 * @return {string}
 */
proto.legebill.type.TagKeyword.prototype.getTagId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.type.TagKeyword} returns this
 */
proto.legebill.type.TagKeyword.prototype.setTagId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string text = 2;
 * @return {string}
 */
proto.legebill.type.TagKeyword.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.type.TagKeyword} returns this
 */
proto.legebill.type.TagKeyword.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


goog.object.extend(exports, proto.legebill.type);
